/**
 * Copyright (C) Firstlight Media. All rights reserved.
 * All information contained herein is and remains the property of Firstlight Media.
 * The intellectual and technical concepts contained herein are proprietary
 * to Firstlight Media. Dissemination of this information or reproduction
 * of this material is strictly forbidden unless prior written permission
 * is obtained from Firstlight Media.
 */

export enum ContentDataKey {
  /**
   * Unique identifier for content item
   */
  CONTENT_ID = 'content_id',

  /**
   * External identifier for the content, typically from a third-party or external system
   */
  EXTERNAL_CONTENT_ID = 'external_content_id',
  /**
   * Identifier for enrichment content, used for linking additional metadata or related assets
   */
  ENRICHMENT_CONTENT_ID = 'enrichment_content_id',
  /**
   * Content type
   */
  CONTENT_TYPE = 'content_type',
  /**
   * Content name from CMS to ensure accurate title if different from the player title
   */
  CONTENT_NAME = 'content_name',
  /**
   * Content name from CMS to ensure accurate title if different from the player title
   */
  PROVIDER_ID = 'provider_id',
  /**
   * Genre of the content
   */
  GENRE = 'genre',
  /**
   * Name of the series
   */
  SERIES_NAME = 'series_name',
  /**
   * Series identifier
   */
  SERIES_ID = 'series_id',
  /**
   * Season number
   */
  SEASON_NUMBER = 'season_number',
  /**
   * Episode number
   */
  EPISODE_NUMBER = 'episode_number',
  /**
   * Playlist identifier
   */
  PLAYLIST_ID = 'playlist_id',
  /**
   * Playlist name
   */
  PLAYLIST_NAME = 'playlist_name',
  /**
   * From content metadata, the license window start date
   */
  LICENSE_WINDOW_START_DATE = 'license_window_start_date',
  /**
   * Name of the sport
   */
  SPORT_NAME = 'sport',
  /**
   * Unique identifier for league
   */
  LEAGUE_ID = 'league_id',
  /**
   * External identifier for league
   */
  LEAGUE_EXTERNAL_ID = 'league_external_id',
  /**
   * Name of the league
   */
  LEAGUE_NAME = 'league_name',
  /**
   * Short name of the league
   */
  LEAGUE_SHORT_NAME = 'league_short_name',
  /**
   * Game unique identifier
   */
  GAME_ID = 'game_id',
  /**
   * Game external identifier
   */
  GAME_EXTERNAL_ID = 'game_external_id',
  /**
   * Name of the venue
   */
  VENUE_NAME = 'venue_name',
  /**
   * City of the venue
   */
  VENUE_CITY = 'venue_city',
  /**
   * Country of the venue
   */
  VENUE_COUNTRY = 'venue_country',
  /**
   * Unique identifier for team 1
   */
  TEAM1_ID = 'team1_id',
  /**
   * External identifier for team 1
   */
  TEAM1_EXTERNAL_ID = 'team1_external_id',
  /**
   * Name of team 1
   */
  TEAM1_NAME = 'team1_name',
  /**
   * Short name for team 1
   */
  TEAM1_SHORT_NAME = 'team1_short_name',
  /**
   * Unique identifier for team 2
   */
  TEAM2_ID = 'team2_id',
  /**
   * External identifier for team 2
   */
  TEAM2_EXTERNAL_ID = 'team2_external_id',
  /**
   * Name of team 2
   */
  TEAM2_NAME = 'team2_name',
  /**
   * Short name for team 2
   */
  TEAM2_SHORT_NAME = 'team2_short_name',
  /**
   * Channel name
   */
  CHANNEL = 'channel',

  /**
   * The name of the brand to which the content belongs
   */
  BRAND = 'brand',
  /**
   * Affiliate or MVPD name for TV Everywhere authenticated services
   */
  AFFILIATE = 'affiliate',
  /**
   * Name of CMS Provider
   */
  ASSET_PROVIDER_NAME = 'asset_provider_name',
  /**
   * name of the cdn
   */
  CDN_NAME = 'cdn_name',
  /**
   * Unique identifier for channel
   */
  CHANNEL_ID = 'channel_id',

  /**
   * Unique identifier for program
   */
  PROGRAM_ID = 'program_id',
  /**
   * Name of the program
   */
  PROGRAM_NAME = 'program_name',
  /**
   * Total duration of the content in seconds.
   */
  CONTENT_DURATION_SEC = 'content_duration_sec',
  /**
   * Language of the content.
   */
  CONTENT_LANGUAGE = 'content_language',
}
